import type { DecoratedOrderTask } from '@witmetrics/utils';
import { differenceInSeconds, getStartOfDay } from '@witmetrics/utils/time';
import type { AgendaTask } from '../types';

export const classes = {
  wrapper: 'absolute py-0 pr-2 pl-1',
  event: 'size-full',
};

export const styles = {
  wrapper: (height: number, offset: number, offsetTop: string) => ({
    height: `${height}px`,
    top: `calc(${offset}px + ${offsetTop})`,
  }),
};

export function getOffset(dueAt: string, hourHeight: number) {
  const diff = differenceInSeconds(getStartOfDay(dueAt), dueAt);
  return hourHeight * (diff / (60 * 60)); // Convert from seconds to hours
}

export function isOrderTask(
  agendaTask: AgendaTask
): agendaTask is DecoratedOrderTask {
  return 'orderId' in agendaTask;
}
